import find from 'lodash/find';

const USER_TRACKING_ID = 'user_tracking_id=';
const PATH = " path='/'";

export function getUserTrackingCookie() {
  const cookie = find(
    document.cookie.split(';'),
    (c) => c.indexOf(`${USER_TRACKING_ID}`) >= 0
  );
  return cookie ? cookie.substr(cookie.indexOf('=') + 1) : '';
}

export function setUserTrackingIdCookie(value) {
  document.cookie = `${USER_TRACKING_ID}${value}; max-age=86400;${PATH}; secure`; // 86400 = 24hrs
}

export function deleteUserTrackingIdToken() {
  document.cookie = `${USER_TRACKING_ID}; expires=0;${PATH}; secure`;
}
